import React, { useState, useEffect } from "react";

const Header = () => {
  const [scrolling, setScrolling] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setScrolling(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 w-full z-50 transition-all  ${
        scrolling ? "bg-white shadow-md" : "bg-transparent shadow-none"
      }`}
    >
      <div className="max-w-8xl mx-auto px-2 sm:px-4 lg:px-6">
        <div className="flex justify-between items-center h-10 md:h-16">
          {/* Brand Logo */}
          <a
            href="/"
            className="block text-gray-800 hover:text-red-600 font-medium transition transform  px-4 py-2 rounded-md"
          >
            <div className="text-xl md:text-2xl font-bold text-red-600">
              Kalka Capital
            </div>
          </a>

          {/* Navigation Links */}
          <nav className="hidden md:flex items-center space-x-1">
            <a
              href="/about"
              className="block text-gray-800 hover:text-red-600 hover:bg-gray-100 font-medium transition transform hover:scale-105 px-4 py-2 rounded-md"
            >
              About
            </a>
            <a
              href="/loan"
              className="block text-gray-800 hover:text-red-600 hover:bg-gray-100 font-medium transition transform hover:scale-105 px-4 py-2 rounded-md"
            >
              Loans
            </a>

            <a
              href="/construction"
              className="block text-gray-800 hover:text-red-600 hover:bg-gray-100 font-medium transition transform hover:scale-105 px-4 py-2 rounded-md"
            >
              Construction
            </a>
            <a
              href="/investment"
              className="block text-gray-800 hover:text-red-600 hover:bg-gray-100 font-medium transition transform hover:scale-105 px-4 py-2 rounded-md"
            >
              Insurance
            </a>
            <a
              href="/business"
              className="block text-gray-800 hover:text-red-600 hover:bg-gray-100 font-medium transition transform hover:scale-105 px-4 py-2 rounded-md"
            >
              Investment & Consulting
            </a>

            <a
              href="/contact"
              className="block text-gray-800 hover:text-red-600 hover:bg-gray-100 font-medium transition transform hover:scale-105 px-4 py-2 rounded-md"
            >
              Contact
            </a>
          </nav>

          {/* Mobile Menu Icon */}
          <button
            className="md:hidden text-gray-800 focus:outline-none"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d={
                  menuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"
                }
              />
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white text-left shadow-md rounded-lg py-4 px-6">
          <a
            href="/about"
            className="block text-gray-800 hover:text-red-600 hover:bg-gray-100 font-medium transition transform hover:scale-105 px-4 py-2 rounded-md"
          >
            About
          </a>
          <a
            href="/loan"
            className="block text-gray-800 hover:text-red-600 hover:bg-gray-100 font-medium transition transform hover:scale-105 px-4 py-2 rounded-md"
          >
            Loans
          </a>

          <a
            href="/construction"
            className="block text-gray-800 hover:text-red-600 hover:bg-gray-100 font-medium transition transform hover:scale-105 px-4 py-2 rounded-md"
          >
            Construction
          </a>
          <a
            href="/investment"
            className="block text-gray-800 hover:text-red-600 hover:bg-gray-100 font-medium transition transform hover:scale-105 px-4 py-2 rounded-md"
          >
            Insurance
          </a>
          <a
            href="/business"
            className="block text-gray-800 hover:text-red-600 hover:bg-gray-100 font-medium transition transform hover:scale-105 px-4 py-2 rounded-md"
          >
           Investment & Consulting
          </a>

          <a
            href="/contact"
            className="block text-gray-800 hover:text-red-600 hover:bg-gray-100 font-medium transition transform hover:scale-105 px-4 py-2 rounded-md"
          >
            Contact
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;
